import { useStyles } from "./MaderaLoader.styles";

const MaderaLoader = () => {
    const classes = useStyles();
    return (
        <div className={classes.maderaLoaderWrapper}>
            {/* Real Madera mark (the same asset used on the HMI navbar), gently pulsing. */}
            <img src="/images/maderaMark64.png" alt="Loading" className={classes.loaderMark} />
        </div>
    );
};

export default MaderaLoader;
